<!-- theMarket Page-->
<section class="theMarketPage">
      <div class="cmsHeaderImg"></div>
       <section class="woodBG">
            <div class="max-800">
                  <div class="PageContent">
                        <h4>Welcome to</h4>
                        <img src="https://hudsonmilk.com/files/9.0%20Resized%20Images/themarket.jpg" alt="The Market Image" width="318" height="212" style="display: block; margin-left: auto; margin-right: auto;">
                        <h6>Located inside our warehouse!</h6>
                        <p><span style="font-size: 14pt; font-weight: 400;"><strong>We have products from all of your favorite Farmer's Market vendors under one roof!<br><span style="color: #800000;">We do the research so you don't have to</span>. Our shelves are stocked with only the best minimally processed food, free from all that stuff you can't pronounce. 
                        </strong><br>
                        <!-- <div class="smTex"> -->
                              Partnering with small, independent farmers and producers who share our commitment to <strong><span style="color: #800000;">REAL FOOD</span></strong>, sustainability, and transparency. Because <strong><span style="color: #800000;">REAL FOOD</span></strong> tastes better, is better for you, and is better for the planet.&nbsp;<br></span>
                        <!-- </div> -->
                  </p>
      
                        <div class="marketWeekendsInfo">
                              <h6>Open Weekends!</h6>
                              <p style="color: white;">at <strong>The Hat Factory</strong><br>1000 North Division St., Suite 21<br>Peekskill, NY</p>
                        </div>
      
                        <div class="marketHoursInfo">
                              <p><span style="color: #800000;"><strong>FRIDAY:</strong></span> <strong>10:00am - 4:00pm</strong><br><strong><span style="color: #800000;">SATURDAY</span><span style="color: #800000;">:</span> 10:00am - 5:00pm</strong><br><strong><span style="color: #800000;">SUNDAY:</span> 10:00am - 2:00pm</strong></p>
                        </div>
                        <div class="marketUpdated">
                              <h6>KEEP ME UPDATED!</h6>
                              <p>Get insider access to the latest from The Market,including upcoming events and promos!</p>
                              <form fxLayout="row">
                                    <div>
                                          <input type="email" class="ctrl" placeholder="Email">
                                    </div>
                                    <div>
                                          <button class="btn">Sign me up!</button>
                                    </div>
                              </form>
                        </div>
      
                  </div>
             </div>
       </section>
       <section class="btnContent">
             <div class="max-1300 text-center">
                 <img class="imgRes" src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" alt="logo">
                 <h3>YOU CAN WHIP OUR CREAM,<br>BUT YOU CAN’T BEAT OUR MILK!</h3>
                 <img src="assets/hudson/files/images/3/content-images/hr-line.svg" alt="design">
                 <div class="getSt"><a href="javascript:void(0)" routerLink="/sign-in" class="btnSqRed">GET STARTED</a></div>
             </div>
       </section>
 </section>